<div class="support_select support-dashboard-filter-card support-dashboard-reporter-filter">
  <div class="support_header">{{ header }}</div>
  <div class="support_types_container">
    <ng-select
      class="support-dashboard-reporter-select"
      [items]="reporterOptions"
      bindLabel="name"
      bindValue="id"
      [multiple]="false"
      [clearable]="true"
      [searchable]="true"
      [loading]="loadingReporters"
      [placeholder]="loadingReporters ? 'Loading reporters...' : placeholder"
      [ngModel]="selectedReporter || null"
      (ngModelChange)="onSelectedReporterChange($event)"
      (change)="onReporterChange($event)"
    >
      <ng-template ng-option-tmp let-item="item">
        <div class="support-dashboard-reporter-option">
          <span>{{ item.name }}</span>
          <!-- <small>{{ item.ticketCount }}</small> -->
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>
